export enum ContactValidationKind {
  PHONE = 'Phone',
  EMAIL = 'Email',
  SOCIAL = 'Social',
  URL = 'Url',
}

export const CONTACT_VALIDATION_KINDS = [
  ContactValidationKind.PHONE,
  ContactValidationKind.EMAIL,
  ContactValidationKind.SOCIAL,
  ContactValidationKind.URL,
] as const;
